/** BSC 56 · bbk-v3 股票底目录（自 DeployForm 同步） */
import {
  flapRwaLogoProxyUrl,
  flapRwaLogoUrl,
  hasFlapRwaLogo,
} from "./flapRwaLogos.js";

export const BBROKER_STOCK_CATALOG = [
  {
    address: "0x10343EF7da3301493D7Ecb647d68A288C6c1Db2F",
    symbol: "AAOIB",
    ticker: "AAOI",
    nameZh: "应用光电",
    nameEn: "Applied Optoelectronics",
    tint: "#00a4ef",
  },
  {
    address: "0x431a3BEE82E2ca41e49895CbECE5bB0F76A89b7A",
    symbol: "AAPLB",
    ticker: "AAPL",
    nameZh: "苹果",
    nameEn: "Apple",
    tint: "#c9a227",
  },
  {
    address: "0x1282493EdE6a22753D45Cb2C0fdBd8D35E97555a",
    symbol: "ALABB",
    ticker: "ALAB",
    nameZh: "Astera Labs",
    nameEn: "Astera Labs",
    tint: "#f97316",
  },
  {
    address: "0xa304BD78e739C0F777202B3eB73Ac3736d1df801",
    symbol: "AMATB",
    ticker: "AMAT",
    nameZh: "应用材料",
    nameEn: "Applied Materials",
    tint: "#555555",
  },
  {
    address: "0x75Fd4cF6f8392E41E70391D60c90C0D5211603a1",
    symbol: "AMDB",
    ticker: "AMD",
    nameZh: "超威半导体",
    nameEn: "Advanced Micro Devices Inc",
    tint: "#4285f4",
  },
  {
    address: "0x1a4b499833A79A09ad7Cf1D42D7DacF71e92eb00",
    symbol: "AMZNB",
    ticker: "AMZN",
    nameZh: "亚马逊",
    nameEn: "Amazon",
    tint: "#4285f4",
  },
  {
    address: "0xD42A79ebb7F527F40fAecD196FFB47aD5e8D6f8C",
    symbol: "ARMB",
    ticker: "ARM",
    nameZh: "安谋",
    nameEn: "Arm Holdings",
    tint: "#7c3aed",
  },
  {
    address: "0xFbfB4f79cFB4C34DCd7C82Bdee5A0Fa199B2e7f9",
    symbol: "ASMLB",
    ticker: "ASML",
    nameZh: "阿斯麦",
    nameEn: "ASML Holding",
    tint: "#a855f7",
  },
  {
    address: "0x58b6F5fEeb8436489F5bf4a56619092B1FA8E777",
    symbol: "ASTSB",
    ticker: "ASTS",
    nameZh: "AST SpaceMobile",
    nameEn: "AST SpaceMobile",
    tint: "#cc0000",
  },
  {
    address: "0x76682c454467b3A1150Ad8b6a92FC5eE2C21d7eD",
    symbol: "AVGOB",
    ticker: "AVGO",
    nameZh: "博通",
    nameEn: "Broadcom",
    tint: "#a855f7",
  },
  {
    address: "0x9BDC8B470dbf89DbCb123587C6f5E49cCA3463BE",
    symbol: "AXTIB",
    ticker: "AXTI",
    nameZh: "AXT",
    nameEn: "AXT Inc",
    tint: "#4285f4",
  },
  {
    address: "0x4eF9d3062c7F6ebA4AAE4990c5036598C6eff4ec",
    symbol: "BABAB",
    ticker: "BABA",
    nameZh: "阿里巴巴",
    nameEn: "Alibaba",
    tint: "#00a4ef",
  },
  {
    address: "0x5519de00F5388c17d886b97Cb5D2D43a812a82bC",
    symbol: "BEB",
    ticker: "BE",
    nameZh: "Bloom Energy",
    nameEn: "Bloom Energy",
    tint: "#0ea5e9",
  },
  {
    address: "0x3548Da95a9eFFE481e8604664d75e95821e557F5",
    symbol: "BMNRB",
    ticker: "BMNR",
    nameZh: "Bitmine",
    nameEn: "Bitmine",
    tint: "#06b6d4",
  },
  {
    address: "0xe81C6bB0266cd68B4F17278531Dd03eA1F12dA4E",
    symbol: "CBRSB",
    ticker: "CBRS",
    nameZh: "CBRS",
    nameEn: "CBRS",
    tint: "#ef4444",
  },
  {
    address: "0x5131859a059B2446AbeeFe0f5d313b3c54Ff3D36",
    symbol: "COHRB",
    ticker: "COHR",
    nameZh: "相干公司",
    nameEn: "Coherent",
    tint: "#6366f1",
  },
  {
    address: "0x585BDE7C54ABB5cCD7791F923D6c2187635f3952",
    symbol: "COINB",
    ticker: "COIN",
    nameZh: "Coinbase",
    nameEn: "Coinbase",
    tint: "#f59e0b",
  },
  {
    address: "0x80f3D493EBCe97e343c53D29a137942416B4ffC0",
    symbol: "CRCLB",
    ticker: "CRCL",
    nameZh: "Circle",
    nameEn: "Circle",
    tint: "#f97316",
  },
  {
    address: "0x6E7D451F9D30327D32020f116Fa79C23B24E9c8D",
    symbol: "CRDOB",
    ticker: "CRDO",
    nameZh: "Credo",
    nameEn: "Credo Technology",
    tint: "#14b8a6",
  },
  {
    address: "0x33E7317e17838fEE56b10Fe8D0B9cA6CA3090c95",
    symbol: "CRWVB",
    ticker: "CRWV",
    nameZh: "CoreWeave",
    nameEn: "CoreWeave",
    tint: "#00a4ef",
  },
  {
    address: "0x0e7A51966c66648999d506e1372EFDeA1B78cb0B",
    symbol: "DELLB",
    ticker: "DELL",
    nameZh: "戴尔",
    nameEn: "Dell Technologies",
    tint: "#e87722",
  },
  {
    address: "0xF2ec508422174Ee564de98187db9359D318AFB6b",
    symbol: "DJTB",
    ticker: "DJT",
    nameZh: "特朗普媒体",
    nameEn: "Trump Media & Technology Group",
    tint: "#c8102e",
  },
  {
    address: "0x93862d63fd9Fd488B1328E9b47717d75e994a84B",
    symbol: "DRAMB",
    ticker: "DRAM",
    nameZh: "DRAM",
    nameEn: "DRAM",
    tint: "#00a4ef",
  },
  {
    address: "0xBE82F76637DBA2C114C41Df856c2C51e522E2Cb8",
    symbol: "EWYB",
    ticker: "EWY",
    nameZh: "韩国 ETF",
    nameEn: "iShares MSCI South Korea",
    tint: "#0ea5e9",
  },
  {
    address: "0x4af1D41cd9dD950dcA43984b43aaA2A8702714Ac",
    symbol: "FLNCB",
    ticker: "FLNC",
    nameZh: "Fluence 能源",
    nameEn: "Fluence Energy",
    tint: "#00a651",
  },
  {
    address: "0x9b8e987e6fec8cf1380c4dca7071e2c7853aeea1",
    symbol: "FXIon",
    ticker: "FXI",
    nameZh: "中国大盘指数 ETF",
    nameEn: "iShares China Large-Cap ETF (Ondo Tokenized)",
    tint: "#6b8e23",
  },
  {
    address: "0x740e075cBbEa22a082B9d6679e65e82767875b6A",
    symbol: "GLWB",
    ticker: "GLW",
    nameZh: "康宁",
    nameEn: "Corning",
    tint: "#76b900",
  },
  {
    address: "0x46cEeFDa28Dd7207059ed19B0acdc026955bb15C",
    symbol: "GMEB",
    ticker: "GME",
    nameZh: "GameStop",
    nameEn: "GameStop",
    tint: "#ed1c24",
  },
  {
    address: "0x3F53De71c126BdaBAe20f9cD64848d317f6C3238",
    symbol: "GOOGLB",
    ticker: "GOOGL",
    nameZh: "谷歌",
    nameEn: "Alphabet",
    tint: "#c9a227",
  },
  {
    address: "0x20CCe6656E5F7F79f280E2D0F5dB55b401BDbfCe",
    symbol: "GSB",
    ticker: "GS",
    nameZh: "高盛",
    nameEn: "Goldman Sachs",
    tint: "#7c3aed",
  },
  {
    address: "0xA394dCEa3fd3847fD793afBFd163E2e3858B7c65",
    symbol: "HOODB",
    ticker: "HOOD",
    nameZh: "Robinhood",
    nameEn: "Robinhood",
    tint: "#ef4444",
  },
  {
    address: "0xfA273B076Feb8c0FB34e554ae341082323D016A3",
    symbol: "IBMB",
    ticker: "IBM",
    nameZh: "IBM",
    nameEn: "IBM",
    tint: "#c9a227",
  },
  {
    address: "0xe614E2fc6C787035FF51f452e8E826Bfd32D5283",
    symbol: "INTCB",
    ticker: "INTC",
    nameZh: "英特尔",
    nameEn: "Intel",
    tint: "#f97316",
  },
  {
    address: "0x0735D9904b7e34e6fe39B0f66E00c111b3f2b681",
    symbol: "INTWB",
    ticker: "INTW",
    nameZh: "INTW",
    nameEn: "INTW",
    tint: "#f97316",
  },
  {
    address: "0xfdc2F2caB77b28f7Ef6c819A404706cfA9bCA33b",
    symbol: "IRENB",
    ticker: "IREN",
    nameZh: "Iris Energy",
    nameEn: "Iris Energy",
    tint: "#00a4ef",
  },
  {
    address: "0x1FFAD32d69c5FEAd99f88C25ca0191Edc3757636",
    symbol: "KORUB",
    ticker: "KORU",
    nameZh: "韩国杠杆 ETF",
    nameEn: "Direxion Korea Bull 3X",
    tint: "#555555",
  },
  {
    address: "0x64748BeA17b6D19e242ADf20425DE2440c656142",
    symbol: "LITEB",
    ticker: "LITE",
    nameZh: "Lumentum",
    nameEn: "Lumentum",
    tint: "#00a4ef",
  },
  {
    address: "0x7425889FE94F9d693E8daefE88BCCed6AcFEf4c0",
    symbol: "METAB",
    ticker: "META",
    nameZh: "Meta",
    nameEn: "Meta Platforms",
    tint: "#cc0000",
  },
  {
    address: "0x5fd86da9B05abE396fe9d02a4A213A7c00556503",
    symbol: "MRNAB",
    ticker: "MRNA",
    nameZh: "莫德纳",
    nameEn: "Moderna",
    tint: "#d71920",
  },
  {
    address: "0x16cd4fe7e8880ECc3ba222795229E20489fc2C76",
    symbol: "MRVLB",
    ticker: "MRVL",
    nameZh: "美满电子",
    nameEn: "Marvell Technology",
    tint: "#555555",
  },
  {
    address: "0x80106cb3EAD06659A5ad19DF39D9b4733863B9b0",
    symbol: "MSFTB",
    ticker: "MSFT",
    nameZh: "微软",
    nameEn: "Microsoft",
    tint: "#7c3aed",
  },
  {
    address: "0xE87afb3076AeB0f9B14E368DE8145ae6a2826A14",
    symbol: "MSTRB",
    ticker: "MSTR",
    nameZh: "微策略",
    nameEn: "MicroStrategy",
    tint: "#c9a227",
  },
  {
    address: "0xcdf2f3e0fa43C47A6662a91C9E4a7C5f69762699",
    symbol: "MUB",
    ticker: "MU",
    nameZh: "美光科技",
    nameEn: "Micron Technology Inc",
    tint: "#f97316",
  },
  {
    address: "0x0bB3fA77E0809f42948E435F04883C25415e8263",
    symbol: "MUUB",
    ticker: "MUU",
    nameZh: "MUU",
    nameEn: "MUU",
    tint: "#f59e0b",
  },
  {
    address: "0x7C26a12f20507E2ceE22CeEBed9e88FDA47f866c",
    symbol: "MVLLB",
    ticker: "MVLL",
    nameZh: "MVLL",
    nameEn: "MVLL",
    tint: "#cc0000",
  },
  {
    address: "0xE256BC2A4F5297F8ba6f043F180a46300eCbCbB1",
    symbol: "NBISB",
    ticker: "NBIS",
    nameZh: "Nebius",
    nameEn: "Nebius",
    tint: "#6366f1",
  },
  {
    address: "0xD6829Ea836b6FA224d099D40E54B31262f874631",
    symbol: "NFLXB",
    ticker: "NFLX",
    nameZh: "奈飞",
    nameEn: "Netflix",
    tint: "#f97316",
  },
  {
    address: "0x7c4d7a180D737Dd5A70d8065a90E6746a69C37EA",
    symbol: "NOKB",
    ticker: "NOK",
    nameZh: "诺基亚",
    nameEn: "Nokia",
    tint: "#00a4ef",
  },
  {
    address: "0x02Fca66C1D1aFB4E2A7884261eB00F63598a7436",
    symbol: "NVDAB",
    ticker: "NVDA",
    nameZh: "英伟达",
    nameEn: "NVIDIA Corp",
    tint: "#f59e0b",
  },
  {
    address: "0x4684D9887fC1c71cBa7baB8E88835CEC217eB598",
    symbol: "ORCLB",
    ticker: "ORCL",
    nameZh: "甲骨文",
    nameEn: "Oracle",
    tint: "#7c3aed",
  },
  {
    address: "0x0Ca5D51D0277Bd006fd9607d3E560785EBad8222",
    symbol: "PLTRB",
    ticker: "PLTR",
    nameZh: "Palantir",
    nameEn: "Palantir",
    tint: "#00a4ef",
  },
  {
    address: "0x2806a561fC1F9259B2d54A281796Bde0D92762aE",
    symbol: "PYPLB",
    ticker: "PYPL",
    nameZh: "PayPal",
    nameEn: "PayPal",
    tint: "#cc0000",
  },
  {
    address: "0x5F7A56e877B9130608Bf8BE962621011182fEfE1",
    symbol: "QCOMB",
    ticker: "QCOM",
    nameZh: "高通",
    nameEn: "Qualcomm",
    tint: "#7c3aed",
  },
  {
    address: "0xd721c192d612Db77621DF57A9fAb38418033c02E",
    symbol: "QNTB",
    ticker: "QNT",
    nameZh: "Quant",
    nameEn: "Quant",
    tint: "#06b6d4",
  },
  {
    address: "0x205812CdBed920aFf76C6580abD681a46D11efc7",
    symbol: "QQQB",
    ticker: "QQQ",
    nameZh: "纳斯达克100指数",
    nameEn: "Invesco QQQ",
    tint: "#1a1a2e",
  },
  {
    address: "0xC8Da12cbCCE7c45180692a6420b0076e03a5179a",
    symbol: "RKLBB",
    ticker: "RKLB",
    nameZh: "Rocket Lab",
    nameEn: "Rocket Lab",
    tint: "#22c55e",
  },
  {
    address: "0xCA750eF65f295BBECd685Abf54e82CAf297BDB61",
    symbol: "SKHYB",
    ticker: "SKHY",
    nameZh: "SK海力士",
    nameEn: "SK Hynix",
    tint: "#e87722",
  },
  {
    address: "0x387dEa1D2772D716d081A29116f3EfFA0fFE1F36",
    symbol: "SMCIB",
    ticker: "SMCI",
    nameZh: "超微电脑",
    nameEn: "Super Micro Computer",
    tint: "#4285f4",
  },
  {
    address: "0xBE1fceD7047fdCE935F45700727845df2c76877a",
    symbol: "SMHB",
    ticker: "SMH",
    nameZh: "半导体 ETF",
    nameEn: "VanEck Semiconductor ETF",
    tint: "#00a4ef",
  },
  {
    address: "0x3eE4dF61bd4F867E349BEaE8bFE07bc31b4850fb",
    symbol: "SNDKB",
    ticker: "SNDK",
    nameZh: "闪迪",
    nameEn: "Sandisk",
    tint: "#76b900",
  },
  {
    address: "0x9e82e3da8f1115B73d24bB24113ab836FfDAb6b6",
    symbol: "SNXXB",
    ticker: "SNXX",
    nameZh: "SNXX",
    nameEn: "SNXX",
    tint: "#ed1c24",
  },
  {
    address: "0xd97d097a89113fa59b76c572E5b2Eb647E8eefaf",
    symbol: "SOXLB",
    ticker: "SOXL",
    nameZh: "半导体杠杆 ETF",
    nameEn: "Direxion Semiconductor Bull 3X",
    tint: "#c9a227",
  },
  {
    address: "0xE28Cd11C99AF2df76bb8aDA4Cd0ef3904378280F",
    symbol: "SOXSB",
    ticker: "SOXS",
    nameZh: "半导体反向 ETF",
    nameEn: "Direxion Semiconductor Bear 3X",
    tint: "#06b6d4",
  },
  {
    address: "0xbe9D156892E55e7154BcD3cB0FEA677F9D3103E1",
    symbol: "SPCXB",
    ticker: "SPCX",
    nameZh: "SpaceX",
    nameEn: "SpaceX",
    tint: "#e91e8c",
  },
  {
    address: "0x7138b48df7D98D7e3cc221BfE7192D0a178182D8",
    symbol: "SPYB",
    ticker: "SPY",
    nameZh: "S&P 500指数",
    nameEn: "SPY",
    tint: "#f97316",
  },
  {
    address: "0x462B5F13B7C7748279358962925c5De83BB9E598",
    symbol: "TQQQB",
    ticker: "TQQQ",
    nameZh: "纳指三倍做多",
    nameEn: "ProShares UltraPro QQQ",
    tint: "#f59e0b",
  },
  {
    address: "0x5b1910eAaD6450E50f816082Aa078C41F10C292f",
    symbol: "TSLAB",
    ticker: "TSLA",
    nameZh: "特斯拉",
    nameEn: "Tesla, Inc.",
    tint: "#ef4444",
  },
  {
    address: "0xAB78b89B5bb00236Be0B4B20704cBfa04EfC711c",
    symbol: "TSMB",
    ticker: "TSM",
    nameZh: "台积电",
    nameEn: "Taiwan Semiconductor",
    tint: "#76b900",
  },
  {
    address: "0xcd345D4450e04cDeF422A60b97D9265d24e0bcEE",
    symbol: "USARB",
    ticker: "USAR",
    nameZh: "USA Rare Earth",
    nameEn: "USA Rare Earth",
    tint: "#0ea5e9",
  },
  {
    address: "0xebe29695F8047C13d36e7a790ca8c1b239FfAD1C",
    symbol: "WDCB",
    ticker: "WDC",
    nameZh: "西部数据",
    nameEn: "Western Digital",
    tint: "#00a4ef",
  },
  {
    address: "0x21cAef8A43163Eea865baeE23b9C2E327696A3bf",
    symbol: "XAUT",
    ticker: "XAUT",
    nameZh: "泰达黄金",
    nameEn: "Tether Gold",
    tint: "#d4a017",
    decimals: 6,
  },
];
/**
 * Flap 官方金库资产 / 股票底池
 * 与 Portal getQuoteTokenConfiguration.enabled===1 对齐（2026-09-14 探测 28 个）
 */
export const OFFICIAL_FLOOR_POOL_SYMBOLS = [
  "SPCXB",
  "SKHYB",
  "SPYB",
  "QQQB",
  "NVDAB",
  "AAPLB",
  "AMZNB",
  "TSLAB",
  "MSFTB",
  "METAB",
  "MSTRB",
  "HOODB",
  "XAUT",
  "BABAB",
  "GMEB",
  "GOOGLB",
  "DJTB",
  "NFLXB",
  "NOKB",
  "TSMB",
  "SOXLB",
  "SOXSB",
  "MRNAB",
  "FLNCB",
  "BMNRB",
  "FXIon",
  "SNXXB",
  "TQQQB",
];

export const DEFAULT_VISIBLE_SYMBOLS = OFFICIAL_FLOOR_POOL_SYMBOLS;

export function officialFloorPoolAssets() {
  return OFFICIAL_FLOOR_POOL_SYMBOLS.map((sym) =>
    BBROKER_STOCK_CATALOG.find((a) => a.symbol === sym)
  ).filter(Boolean);
}

/** 金库 NFT 分红资产：与官方底池同列表（不可与发射支付代币相同） */
export function officialVaultAssetPool() {
  return officialFloorPoolAssets();
}

export const ICON_TINT = {
  SPCXB: "linear-gradient(160deg,#c9a227 0%,#6b4f12 100%)",
  SKHYB: "linear-gradient(160deg,#e87722 0%,#6b2e08 100%)",
  SPYB: "linear-gradient(160deg,#9a7b2f 0%,#3d3010 100%)",
  QQQB: "linear-gradient(160deg,#c2185b 0%,#4a0d24 100%)",
  NVDAB: "linear-gradient(160deg,#8b1a1a 0%,#3d0a0a 100%)",
  AAPLB: "linear-gradient(160deg,#1a4a5c 0%,#0a2030 100%)",
  AMZNB: "linear-gradient(160deg,#ff9900 0%,#4a2e00 100%)",
  TSLAB: "linear-gradient(160deg,#1f6b3a 0%,#0d2e18 100%)",
  MSFTB: "linear-gradient(160deg,#8bc34a 0%,#33691e 100%)",
  METAB: "linear-gradient(160deg,#0668e1 0%,#0a2a5c 100%)",
  MSTRB: "linear-gradient(160deg,#f7931a 0%,#5c3d08 100%)",
  HOODB: "linear-gradient(160deg,#00c805 0%,#0a3d0c 100%)",
  XAUT: "linear-gradient(160deg,#d4a017 0%,#5c3d08 100%)",
  BABAB: "linear-gradient(160deg,#ff6a00 0%,#5c2800 100%)",
  GMEB: "linear-gradient(160deg,#ed1c24 0%,#4a0a0c 100%)",
  GOOGLB: "linear-gradient(160deg,#4285f4 0%,#0f2a5c 100%)",
  DJTB: "linear-gradient(160deg,#c8102e 0%,#4a0a12 100%)",
  NFLXB: "linear-gradient(160deg,#e50914 0%,#4a0508 100%)",
  NOKB: "linear-gradient(160deg,#124191 0%,#0a1e3d 100%)",
  TSMB: "linear-gradient(160deg,#76b900 0%,#2e4800 100%)",
  SOXLB: "linear-gradient(160deg,#c9a227 0%,#5c3d08 100%)",
  SOXSB: "linear-gradient(160deg,#06b6d4 0%,#0a3d4a 100%)",
  MRNAB: "linear-gradient(160deg,#d71920 0%,#4a0a0c 100%)",
  FLNCB: "linear-gradient(160deg,#00a651 0%,#0a3d24 100%)",
  BMNRB: "linear-gradient(160deg,#06b6d4 0%,#0a3d4a 100%)",
  FXIon: "linear-gradient(160deg,#9ccc65 0%,#33691e 100%)",
  SNXXB: "linear-gradient(160deg,#ed1c24 0%,#4a0a0c 100%)",
  TQQQB: "linear-gradient(160deg,#f59e0b 0%,#5c3d08 100%)",
};

export function iconBg(a) {
  return ICON_TINT[a.symbol] ?? `linear-gradient(160deg,${a.tint} 0%,#0a0a0a 100%)`;
}

/** 底层股票 ticker（FMP / 备用 logo） */
const STOCK_LOGO_TICKER = {
  SPCXB: "SPCX",
  SKHYB: "000660.KS",
  SPYB: "SPY",
  QQQB: "QQQ",
  NVDAB: "NVDA",
  AAPLB: "AAPL",
  AMZNB: "AMZN",
  TSLAB: "TSLA",
  MSFTB: "MSFT",
  METAB: "META",
  MSTRB: "MSTR",
  HOODB: "HOOD",
  XAUT: "XAU",
  BABAB: "BABA",
  GMEB: "GME",
  GOOGLB: "GOOGL",
  DJTB: "DJT",
  NFLXB: "NFLX",
  NOKB: "NOK",
  TSMB: "TSM",
  SOXLB: "SOXL",
  SOXSB: "SOXS",
  MRNAB: "MRNA",
  FLNCB: "FLNC",
  BMNRB: "BMNR",
  FXIon: "FXI",
  SNXXB: "SNXX",
  TQQQB: "TQQQ",
};

/**
 * 官方 logo 候选
 * 1) 站内 Flap SVG /images/stocks/{SYMBOL}.svg（fetch-flap-rwa-logos / cache_flap_rwa_logos）
 * 2) flap.sh 官方 SVG（Corla 同款）
 * 3) 同源代理 /api/flap_logo.php
 * 4) 站内 PNG 兜底
 * 5) TrustWallet / FMP
 */
export function stockLogoCandidates(a) {
  if (!a?.address) return [];
  const checksum = String(a.address);
  const symbol = String(a.symbol || "").trim().toUpperCase();
  const ticker =
    STOCK_LOGO_TICKER[a.symbol] ||
    String(a.ticker || "").replace(/\.$/, "") ||
    "";
  const list = [];
  if (symbol) {
    list.push(`/images/stocks/${symbol}.svg`);
    if (hasFlapRwaLogo(symbol)) {
      const flap = flapRwaLogoUrl(symbol);
      if (flap) list.push(flap);
      const proxy = flapRwaLogoProxyUrl(symbol);
      if (proxy) list.push(proxy);
    }
    list.push(`/images/stocks/${symbol}.png`);
  }
  list.push(
    `https://cdn.jsdelivr.net/gh/trustwallet/assets@master/blockchains/smartchain/assets/${checksum}/logo.png`,
    `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/${checksum}/logo.png`
  );
  if (ticker) {
    list.push(
      `https://financialmodelingprep.com/image-stock/${encodeURIComponent(ticker)}.png`
    );
  }
  return list;
}

export function stockLogoUrl(a) {
  return stockLogoCandidates(a)[0] || "";
}
